import { Series } from '../types/'

const isSeries = (item: any): boolean => {
  return (item as Series).challenges !== undefined
}

export { isSeries }
